export default "__VITE_ASSET__DGMQwiIX__"